export default function USP() {
  const features = [
    {
      icon: "ri-brain-line",
      title: "KI-gestützte Reflexion",
      description: "Mindshift AI stellt dir die richtigen Fragen zur richtigen Zeit und hilft dir, deine Gedanken zu ordnen und neue Perspektiven zu entdecken.",
      image: "https://public.readdy.ai/ai/img_res/9a8bccd68f5e53f42620e830d4f13f77.jpg"
    },
    {
      icon: "ri-calendar-check-line",
      title: "Tägliche Check-ins",
      description: "Erfasse deine Stimmung, Energie und Gedanken in nur 2-3 Minuten. Die KI erkennt Muster und gibt dir wertvolle Einblicke in dein Wohlbefinden.",
      image: "https://readdy.ai/api/search-image?query=young%20person%20sitting%20at%20cozy%20desk%20with%20morning%20coffee%20writing%20in%20journal%20or%20looking%20at%20phone%20with%20satisfied%20expression%20natural%20daylight%20streaming%20through%20window%20plants%20and%20teal%20turquoise%20decor%20elements%20peaceful%20morning%20routine%20self-care%20moment%20lifestyle%20photography%20warm%20soft%20lighting&width=600&height=400&seq=usp-checkin-person&orientation=landscape"
    },
    {
      icon: "ri-target-line",
      title: "Smarte Zielverfolgung",
      description: "Definiere Ziele in 8 Lebensbereichen und erhalte personalisierte Handlungsempfehlungen. Die KI hilft dir, fokussiert zu bleiben und Fortschritte zu feiern.",
      image: "https://readdy.ai/api/search-image?query=motivated%20person%20standing%20confidently%20with%20arms%20crossed%20or%20raised%20in%20achievement%20pose%20bright%20modern%20space%20with%20teal%20turquoise%20color%20accents%20successful%20happy%20expression%20looking%20forward%20with%20determination%20natural%20lighting%20inspiring%20atmosphere%20personal%20growth%20and%20goal%20achievement%20moment%20lifestyle%20photography&width=600&height=400&seq=usp-goals-person&orientation=landscape"
    },
    {
      icon: "ri-book-open-line",
      title: "Privates Journal",
      description: "Schreibe deine Gedanken in einem sicheren, verschlüsselten Raum auf. Die KI analysiert deine Einträge und gibt dir tiefere Einblicke in deine Entwicklung.",
      image: "https://readdy.ai/api/search-image?query=person%20sitting%20comfortably%20on%20sofa%20or%20armchair%20writing%20thoughtfully%20in%20journal%20or%20on%20tablet%20peaceful%20expression%20soft%20natural%20light%20cozy%20home%20environment%20with%20teal%20turquoise%20cushions%20and%20decor%20private%20reflective%20moment%20calm%20atmosphere%20wellness%20and%20journaling%20lifestyle%20photography%20warm%20lighting&width=600&height=400&seq=usp-journal-person&orientation=landscape"
    },
    {
      icon: "ri-line-chart-line",
      title: "Fortschritts-Visualisierung",
      description: "Sieh deine Entwicklung in interaktiven Diagrammen und erkenne Zusammenhänge zwischen deinen Gewohnheiten und deinem Wohlbefinden.",
      image: "https://readdy.ai/api/search-image?query=happy%20person%20looking%20at%20laptop%20or%20tablet%20screen%20with%20pleased%20surprised%20expression%20seeing%20positive%20results%20graphs%20visible%20on%20screen%20bright%20modern%20workspace%20with%20teal%20turquoise%20elements%20natural%20daylight%20achievement%20and%20progress%20moment%20lifestyle%20photography%20professional%20yet%20warm%20atmosphere&width=600&height=400&seq=usp-progress-person&orientation=landscape"
    },
    {
      icon: "ri-lightbulb-line",
      title: "Personalisierte Erkenntnisse",
      description: "Erhalte wöchentliche KI-generierte Insights, die dir helfen, dich selbst besser zu verstehen und positive Veränderungen anzustoßen.",
      image: "https://readdy.ai/api/search-image?query=person%20having%20aha%20moment%20with%20hand%20on%20chin%20or%20touching%20head%20thoughtful%20inspired%20expression%20sitting%20in%20bright%20space%20with%20natural%20light%20teal%20turquoise%20color%20elements%20in%20background%20moment%20of%20realization%20and%20insight%20peaceful%20atmosphere%20personal%20development%20lifestyle%20photography%20soft%20warm%20lighting&width=600&height=400&seq=usp-insights-person&orientation=landscape"
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-6 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-star-line mr-2"></i>
            Deine Features
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Alles, was du für deine persönliche Entwicklung brauchst
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Mindshift AI kombiniert bewährte Coaching-Methoden mit modernster KI-Technologie
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg">
                  <i className={`${feature.icon} text-2xl text-teal-600`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Security & Privacy Info */}
        <div className="mt-16 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl p-8">
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div>
              <i className="ri-shield-check-line text-4xl text-teal-600 mb-3"></i>
              <h4 className="font-semibold text-gray-900 mb-2">DSGVO-konform</h4>
              <p className="text-sm text-gray-600">In Deutschland gehostet</p>
            </div>
            <div>
              <i className="ri-lock-line text-4xl text-teal-600 mb-3"></i>
              <h4 className="font-semibold text-gray-900 mb-2">Ende-zu-Ende verschlüsselt</h4>
              <p className="text-sm text-gray-600">Deine Daten bleiben privat</p>
            </div>
            <div>
              <i className="ri-user-line text-4xl text-teal-600 mb-3"></i>
              <h4 className="font-semibold text-gray-900 mb-2">Pseudonyme erlaubt</h4>
              <p className="text-sm text-gray-600">100% anonym nutzbar</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
